import React from 'react';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import IconMessageColumn from '../../../components/columns/icon-message-column';
import Global from '../../../store/global-selectors';
import { marketplaceNotifiedToState } from '../../../constants/marketplace-notifications';

import { messages } from '../messages';

const MarketplaceNotifiedColumn = ({ fulfillmentId }) => {
  const { marketplaceNotification } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const amazonUpdate = useSelector((state) =>
    Global.selectShipmentsGridAmazonStatusUpdateByFulfillmentId(state, {
      fulfillmentId,
    }),
  );

  const { status, errorMessage } = amazonUpdate ?? marketplaceNotification ?? {};

  const state = marketplaceNotifiedToState[status];

  const fallbackTooltip = amazonUpdate?.sent ? messages.notificationSent : messages.marketplaceNotified;
  const tooltipMessage = errorMessage || <FormattedMessage {...fallbackTooltip} />;
  const iconMessage = amazonUpdate?.sent ? messages.sent : messages.notified;

  return (
    <IconMessageColumn
      icon={faPaperPlane}
      message={<FormattedMessage {...iconMessage} />}
      popoverFlyoutTitle={<FormattedMessage {...messages.marketplaceNotifiedTooltipTitle} />}
      state={state}
      tooltipMessage={tooltipMessage}
    />
  );
};

MarketplaceNotifiedColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const MarketplaceNotified = {
  getMessageDescriptor: () => messages.marketplaceNotified,
  id: 'marketplace-notified',

  render: (data) => {
    return <MarketplaceNotifiedColumn fulfillmentId={data.id} />;
  },
};
